/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Typography,
  CircularProgress,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";

import "./style.css";
import { useSelector } from "react-redux";
import NewConnectorDetails from "../NewConnectorDetails";
import Axios from "../../../config";
import { toast } from "helpers/apiRequests";
import mysql from '../../../assets/icons/mysqlv2.svg';
import postgresql from '../../../assets/icons/postgresql.svg';

const CreateNewConnector = ({ openModal, handleClose, addConnectors }) => {
  const sql = useSelector((state) => state.connector.sql_sync);
  const [drivers, setDrivers] = useState([]);
  const [responseData, setResponseData] = useState({
    show: false,
    data: []
  });
  const handlResponseChange = (val) => {
    setResponseData({
      show: true,
      data: [...val]
    });
    handleClose();
    setOpen(true)
  }
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const handleModalClose = () => {
    setResponseData({
      show: false,
      data: []
    });
    setOpen(false);
  }
  const [org, setOrg] = useState("");

  const orgs = useSelector((state) => state.sync.orgs);
  const orgOptions = orgs.length > 0 ? orgs.map(org => {
    return <option key={org.org_id} value={org.org_id}>{org.name}</option>
  }) : null;

  const changeOrganisation = (e) => {
    const { value } = e.target;
    setOrg(value);
  }

  const saveLoading = () => {
    setLoading(false)
  }

  const createNewUserMySqlDB = async () => {
    try {
      setLoading(true);
      let payload;
      if (!drivers.length) {
        payload = {};
      } else if (drivers.length === 1) {
        payload = {
          drivers: drivers,
        };
      } else {
        payload = {
          drivers: drivers
        };
        console.log(payload);
      }
      const requestData = {
        org_id: org,
        ...payload
      };
      console.log(requestData);
      const url = `/create-user-db`;
      const res = await Axios.post(url, requestData);
      addConnectors(res.data);
      handlResponseChange(res.data)
      setLoading(false);
      toast.notify(res.message);

    } catch (error) {
      setLoading(false);
      let msg = error.response.message
      if (error.response.data.error_list && error.response.data.error_list.length > 0) {
        msg = error.response.data.error_list[0].message;
      }
      toast.notify(msg,{ type: "error" });
    }
  };

  const addorRemoveDrivers = (e) => {
    const { checked, value } = e.target;
    if (!checked) {
      let filterDrivers = drivers.filter((drive) => drive !== value);
      return setDrivers(filterDrivers);
    }
    return setDrivers((prevState) => [...prevState, value]);
  };


  return (
    <div>
      <NewConnectorDetails
        openModal={open}
        handleClose={handleModalClose}
        responseData={responseData}
      />
      <Dialog
        open={openModal}
        onClose={handleClose}
        // hideBackdrop={true}
        disableBackdropClick={false}
        disableEscapeKeyDown={true}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        id="connector-modal"
      >
        <DialogContent>

          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <Typography variant="h6">
                Create Connection.
              </Typography>
              <div className="form-group mt-3">
                <label htmlFor="app">Select Organization</label>
                <select
                  className='form-control'
                  value={org}
                  onChange={changeOrganisation}
                >
                  <option>Select An Organization</option>
                  {orgOptions}
                </select>
              </div>

              <Typography gutterBottom>
                Select either MySQL or PostgreSQL to create a new database.
              </Typography>
              <div className="mt-2">
                <img src={mysql} alt="mysql" className="mb-3 mr-2" width={50} />
                <FormControlLabel
                  control={
                    <Checkbox onChange={addorRemoveDrivers} value={"mysql"} name={"mysql"} />
                  }
                  label={`MySql`}

                >


                </FormControlLabel>
                <img src={postgresql} alt="postgresql" width={50} />
                <FormControlLabel
                  control={
                    <Checkbox onChange={addorRemoveDrivers} value={"pgsql"} name={"pgsql"} />
                  }
                  label={`PostgreSql`}
                >


                </FormControlLabel>

              </div>

              <Typography gutterBottom>
                You are about setting up MySQL/PGSQL syncing.
                <br />
                Would you like to proceed?
              </Typography>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button id="button-cancel" disabled={loading} onClick={handleClose} color="primary">
              No
            </Button>
            {loading ? (
              <CircularProgress size={24} />
            ) : (
              <Button id="button-save" onClick={createNewUserMySqlDB} color="primary" autoFocus>
                Yes
              </Button>
            )}
          </DialogActions>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default CreateNewConnector;
